module.exports = __webpack_public_path__ + "graphics/agency/DOJ.jpg";